exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3LaLNccLrSgb4-nDZ5HTGM{font-family:sans-serif}div._3LaLNccLrSgb4-nDZ5HTGM{text-align:center;padding:5px;background-color:#e1e1e1;border-radius:5px;min-height:60px;border:2px dashed #c7c7c7}._3EG6jM57rkQg0yzKX22kk4{position:relative;display:inline-block;margin:1.5em 0 2.5em;padding-left:45px;color:#000}._3EG6jM57rkQg0yzKX22kk4:before{position:absolute;top:-7px;left:0;width:29px;height:34px;content:\"\";border:2px solid #7f7f7f;border-radius:2px}._3EG6jM57rkQg0yzKX22kk4:after{font-size:11px;line-height:1.3;position:absolute;top:9px;left:-4px;padding:0 2px;content:\"file\";content:attr(data-filetype);text-align:right;letter-spacing:1px;text-transform:uppercase;color:#fff;background-color:#000}._3EG6jM57rkQg0yzKX22kk4 ._1Fx-oG-OVG_HSXT9QFiv3F{position:absolute;top:-7px;left:22px;width:0;height:0;border-width:11px 0 0 11px;border-style:solid;border-color:#fff transparent transparent #920035}", ""]);

// exports
exports.locals = {
	"filepicker": "_3LaLNccLrSgb4-nDZ5HTGM",
	"filepicker-file-icon": "_3EG6jM57rkQg0yzKX22kk4",
	"fileCorner": "_1Fx-oG-OVG_HSXT9QFiv3F"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./~/react-dropzone-component/styles/filepicker.css
 ** module id = 1027
 ** module chunks = 0
 **/